import { Loader } from '@recruit-robin/robin-theme/web-components';
import { Suspense } from 'react';
import { useStyles } from './RoutesSuspense.styles';

type RoutesSuspenseProps = {
  children: React.ReactNode;
  /**
   * Replaces the app-wide spinner for one route.
   *
   * Routes that carry another brand cannot show Robin's loader on the way in — the first
   * painted frame is the one that says whose product this is. Every other route omits it
   * and keeps the shared fallback.
   */
  fallback?: React.ReactNode;
};

export const RoutesSuspense = ({ children, fallback }: RoutesSuspenseProps) => {
  const classes = useStyles();

  return (
    <Suspense
      fallback={
        fallback ?? (
          <div css={classes.root}>
            <Loader size={48} />
          </div>
        )
      }>
      {children}
    </Suspense>
  );
};
